import React from 'react'
import Markdown from 'react-markdown'

import MessageBubble from './MessageBubble'
import UserAvatar from '../../containers/users/Avatar'
import AdvisorAvatar from './AdvisorAvatar'
import AnswerSources from './AnswerSources'
import { AdvisorAvatarType, AdvisorMessage } from '../../../api/gpt/types'

type MessageListProps = { messages: Array<AdvisorMessage>, messageInProgress?: React.ReactNode }
const MessageList:React.FC<MessageListProps> = ({ messages, messageInProgress }) => {
  if(!messages || messages.length === 0) return null

  return (
    <div className='overflow-y-auto pe-3 md:px-4 w-full flex flex-col-reverse' >
      {messageInProgress && (
        <div className='w-full max-w-2xl mx-auto'>
          {messageInProgress}
        </div>
      )}
      {messages?.map((msg, i) => (
        <div key={i} className='w-full max-w-2xl mx-auto'>
          <MessageBubble
            avatar={msg.role === AdvisorAvatarType.USER ? <UserAvatar hideSubscriptionTag /> : <AdvisorAvatar />}
            message={
              <>
                <Markdown>{msg.content}</Markdown>
                {msg.sources && <AnswerSources sources={msg.sources} />}
              </>
            }
          />
        </div>
      ))}
    </div>
  )
}

export default MessageList
